import { render, staticRenderFns } from "./ZadiComingSoon.vue?vue&type=template&id=1996515f&scoped=true&"
import script from "./ZadiComingSoon.vue?vue&type=script&lang=js&"
export * from "./ZadiComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ZadiComingSoon.vue?vue&type=style&index=0&id=1996515f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996515f",
  null
  
)

export default component.exports